import * as React from "react";
import FormControl from "@mui/material/FormControl";

import { connect } from "react-redux";
import { useDispatch } from "react-redux";
import {
  USER_DATECHANGEFINAL_STATE_CHANGE,
  USER_DATECHANGEINICIO_STATE_CHANGE,
} from "../../redux/constanst/index";

import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { mapStateToProps, mesArr } from "./models/buscar";
import { ButtonGroup, InputLabel, MenuItem, Select } from "@mui/material";
import SelectsTags from "./InicioFunctions/selectsTags";
import { useEffect } from "react";

function CustomizedSelects(props) {
  const dispatch = useDispatch();

  const [thunk] = React.useState(false);
  const [thunk2] = React.useState(false);

  const [date] = React.useState({});

  const [inicioChange, setInicioChange] = React.useState({
    dia: null,
    mes: null,
    year: null,
  });

  const years = [2022, 2023,2024];

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (thunk === true) {
      handlerChangeStore();
    }

    if (thunk2 === true) {
      handlerChangeStoreF();
    }

    if (Object.entries(date).length > 0 && !inicioChange.dia) {
      if (date.inicio) {
        let mesNum = 0;
        switch (date.inicio.mes) {
          case "Enero":
            mesNum = 1;
            break;
          case "Febrero":
            mesNum = 2;
            break;
          case "Marzo":
            mesNum = 3;
            break;
          case "Abril":
            mesNum = 4;
            break;
          case "Mayo":
            mesNum = 5;
            break;
          case "Junio":
            mesNum = 6;
            break;
          case "Julio":
            mesNum = 7;
            break;
          case "Agosto":
            mesNum = 8;
            break;
          case "Septiembre":
            mesNum = 9;
            break;
          case "Octubre":
            mesNum = 10;
            break;
          case "Noviembre":
            mesNum = 11;
            break;
          case "Diciembre":
            mesNum = 12;
            break;
          default:
            break;
        }
        setInicioChange({
          dia: date.inicio.dia,
          mes: mesNum,
          year: 2024,
        });

        handlerChangeStore(date.inicio);
      }
    }
  });

  const handlerChangeStore = (fecha, valor) => {
    let fechaLista;
    if (fecha === "dia") {
      fechaLista = {
        dia: valor,
        mes: props.dateChangeInicio.mes,
        year: props.dateChangeInicio.year,
      };
    } else if (fecha === "mes") {
      fechaLista = {
        dia: props.dateChangeInicio.dia,
        mes: valor,
        year: props.dateChangeInicio.year,
      };
    } else {
      fechaLista = {
        dia: props.dateChangeInicio.dia,
        mes: props.dateChangeInicio.mes,
        year: valor,
      };
    }

    dispatch({
      type: USER_DATECHANGEINICIO_STATE_CHANGE,
      dateChangeInicio: fechaLista,
    });
  };

  const handlerChangeStoreF = (fecha, valor) => {
    let fechaLista;
    if (fecha === "dia") {
      fechaLista = {
        dia: valor,
        mes: props.dateChangeFinal.mes,
        year: props.dateChangeFinal.year,
      };
    } else if (fecha === "mes") {
      fechaLista = {
        dia: props.dateChangeFinal.dia,
        mes: valor,
        year: props.dateChangeFinal.year,
      };
    } else {
      fechaLista = {
        dia: props.dateChangeFinal.dia,
        mes: props.dateChangeFinal.mes,
        year: valor,
      };
    }
    dispatch({
      type: USER_DATECHANGEFINAL_STATE_CHANGE,
      dateChangeFinal: fechaLista,
    });
  };

  return (
    <div
      style={{
        display: "flex",
        marginLeft: 20,
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        height: 20,
      }}
    >
      <div style={{ marginRight: 10 }}>
        <ButtonGroup variant="outlined" aria-label="outlined button group">
          <SelectsTags />
        </ButtonGroup>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          marginBottom: 20,
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <p style={{ marginTop: 15, fontSize: 12 }}>Inicial</p>
        <FormControl sx={{ m: 1 }} variant="standard">
          <Autocomplete
            size="small"
            disablePortal
            id="combo-box-demo"
            options={días}
            onInputChange={async (event, newInputValue) => {
              handlerChangeStore("dia", parseInt(newInputValue));
            }}
            sx={{ width: 90, maxWidth: 80 }}
            style={{ height: 20 }}
            renderInput={(params) => (
              <TextField {...params} label={props.dateChangeInicio.dia} />
            )}
          />
        </FormControl>
        <FormControl sx={{ m: 1 }} variant="standard">
          <Autocomplete
            size="small"
            disablePortal
            id="combo-box-demo"
            options={meses}
            onInputChange={(event, newInputValue) => {
              let mesNum = 0;
              switch (newInputValue) {
                case "Enero":
                  mesNum = 1;
                  break;
                case "Febrero":
                  mesNum = 2;
                  break;
                case "Marzo":
                  mesNum = 3;
                  break;
                case "Abril":
                  mesNum = 4;
                  break;
                case "Mayo":
                  mesNum = 5;
                  break;
                case "Junio":
                  mesNum = 6;
                  break;
                case "Julio":
                  mesNum = 7;
                  break;
                case "Agosto":
                  mesNum = 8;
                  break;
                case "Septiembre":
                  mesNum = 9;
                  break;
                case "Octubre":
                  mesNum = 10;
                  break;
                case "Noviembre":
                  mesNum = 11;
                  break;
                case "Diciembre":
                  mesNum = 12;
                  break;
                default:
                  break;
              }
              handlerChangeStore("mes", mesNum);
            }}
            sx={{ width: 200, maxWidth: 200 }}
            style={{ height: 20 }}
            renderInput={(params) => (
              <TextField
                {...params}
                label={mesArr[props.dateChangeInicio.mes]}
              />
            )}
          />
        </FormControl>
        <FormControl sx={{ m: 1 }} variant="standard">
          <Autocomplete
            size="small"
            disablePortal
            id="combo-box-demo"
            options={years}
            onInputChange={(event, newInputValue) => {
              handlerChangeStore("years", newInputValue);
            }}
            sx={{ width: 120, maxWidth: 200 }}
            style={{ height: 20 }}
            renderInput={(params) => (
              <TextField {...params} label={props.dateChangeInicio.year} />
            )}
          />
        </FormControl>
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "row",
          marginBottom: 20,
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <p style={{ marginTop: 15, fontSize: 12 }}>Final</p>
        <FormControl sx={{ m: 1 }} variant="standard">
          <Autocomplete
            size="small"
            disablePortal
            id="combo-box-demo"
            options={días}
            onInputChange={(event, newInputValue) => {
              handlerChangeStoreF("dia", parseInt(newInputValue));
            }}
            sx={{ width: 90, maxWidth: 80 }}
            style={{ height: 20 }}
            renderInput={(params) => (
              <TextField {...params} label={props.dateChangeFinal.dia} />
            )}
          />
        </FormControl>
        <FormControl sx={{ m: 1, marginTop: 4 }}>
          <InputLabel id="demo-simple-select-label">Mes</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            defaultValue={props.dateChangeFinal.mes}
            label="Mes"
            sx={{ width: 200, maxWidth: 200 }}
            style={{ height: 40 }}
            onChange={(e) => {
             
              handlerChangeStoreF("mes", e.target.value);
            }}
          >
            {mesArr.map((data, index) => {
              return <MenuItem value={index}>{data}</MenuItem>;
            })}
          </Select>
         
        </FormControl>
        <FormControl sx={{ m: 1 }} variant="standard">
          <Autocomplete
            size="small"
            disablePortal
            id="combo-box-demo"
            options={years}
            onInputChange={(event, newInputValue) => {
              handlerChangeStoreF("years", newInputValue);
            }}
            sx={{ width: 100, maxWidth: 200 }}
            style={{ height: 20 }}
            renderInput={(params) => (
              <TextField {...params} label={props.dateChangeFinal.year} />
            )}
          />
        </FormControl>
      </div>
    </div>
  );
}

export default connect(mapStateToProps, null)(CustomizedSelects);

const días = [
  { label: "1" },
  { label: "2" },
  { label: "3" },
  { label: "4" },
  { label: "5" },
  { label: "6" },
  { label: "7" },
  { label: "8" },
  { label: "9" },
  { label: "10" },
  { label: "11" },
  { label: "12" },
  { label: "13" },
  { label: "14" },
  { label: "15" },
  { label: "16" },
  { label: "17" },
  { label: "18" },
  { label: "19" },
  { label: "20" },
  { label: "21" },
  { label: "22" },
  { label: "23" },
  { label: "24" },
  { label: "25" },
  { label: "26" },
  { label: "27" },
  { label: "28" },
  { label: "29" },
  { label: "30" },
  { label: "31" },
];

const meses = [
  { label: "Enero" },
  { label: "Febrero" },
  { label: "Marzo" },
  { label: "Abril" },
  { label: "Mayo" },
  { label: "Junio" },
  { label: "Julio" },
  { label: "Agosto" },
  { label: "Septiembre" },
  { label: "Octubre" },
  { label: "Noviembre" },
  { label: "Diciembre" },
];
